import "./ProjectGallery.module.css";
import Navigation from "@/reusable_sections/Header";
import Portfolio from "./sections/Portfolio";
import Projects from "./sections/Projects";
import Footer from "@/reusable_sections/Footer";
export default function ProjectGalleryPage() {
  return <div>
      <Navigation />
      <Portfolio />
      <Projects />
      <Footer />
    </div>;
}